export enum TabIdList {
  history = "history",
  route = "route",
  equipment = "equipment",
}

export const eventDescriptionPlaceholder = "Undefined Event";
